export const content = {
    domain: "eMoneyUSA",
    footer: "emonysusa.com",
    title1: "Loans from $100 - $5,000!",
  };
  